<template>
    <div class="modal-backdrop" @click.self="$emit('close')">
      <div class="modal-custom">
        <div class="modal-header">
          <h5>Create New Group</h5>
          <button @click="$emit('close')" class="btn btn-sm btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label>Group Name</label>
              <input v-model="form.name" type="text" class="form-control" required>
            </div>
            <div class="form-group">
    <label>Group Image</label>
    <div class="image-upload-container">
      <div class="image-preview" @click="triggerImageUpload">
        <img v-if="imagePreview" :src="imagePreview" class="preview-image">
        <div v-else class="upload-placeholder">
          <i class="fas fa-camera"></i>
          <span>Upload Image</span>
        </div>
      </div>
      <input 
        ref="imageInput" 
        type="file" 
        @change="handleImageUpload" 
        accept="image/*"
        style="display: none;"
      >
      <button 
        v-if="imagePreview" 
        @click="removeImage" 
        class="btn btn-sm btn-danger mt-2"
      >
        Remove Image
      </button>
    </div>
  </div>
            <div class="form-group">
              <label>Description</label>
              <textarea v-model="form.description" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input v-model="form.is_public" type="checkbox" class="form-check-input" id="isPublic">
                <label class="form-check-label" for="isPublic">Public Group</label>
              </div>
            </div>
            <div class="form-group" v-if="userHasBadge('moder')">
    <label>Class (optional)</label>
    <select v-model="form.class_id" class="form-control">
      <option value="">Select Class</option>
      <option v-for="classItem in classes" :value="classItem.id">{{ classItem.name }}</option>
    </select>
  </div>
  <div class="form-group" v-if="form.class_id && userHasBadge('moder')">
    <label>Section (optional)</label>
    <select v-model="form.section_id" class="form-control" :disabled="loadingSections">
      <option value="">Select Section</option>
      <option v-if="loadingSections" disabled>Loading sections...</option>
      <option v-else v-for="section in filteredSections" :value="section.id">{{ section.name }}</option>
    </select>
  </div>
            <div class="form-actions">
              <button type="button" @click="$emit('close')" class="btn btn-secondary">Cancel</button>
              <button type="submit" class="btn btn-primary">Create Group</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';

  const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api',
  });
  
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }, (error) => Promise.reject(error));
  
  export default {
    props: {
      classes: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        form: {
          name: '',
          description: '',
          is_public: false,
          class_id: null,
          section_id: null
        },
        sections: [], // Add sections data property
        loadingSections: false ,// Add loading state
        imageFile: null,
        imagePreview: null,
      };
    },
    computed: {
  filteredSections() {
    if (!this.form.class_id || !Array.isArray(this.sections)) return [];
    console.log('Filtering sections:', this.sections); // Debug log
    const filtered = this.sections.filter(section => {
      const matches = section.class_id == this.form.class_id;
      console.log(`Section ${section.id}: class_id=${section.class_id}, matches=${matches}`);
      return matches;
    });
    console.log('Filtered sections:', filtered);
    return filtered;
  }
},
    methods: {
      handleSubmit() {
  const formData = new FormData();
  formData.append('name', this.form.name);
  formData.append('description', this.form.description);
  // Convert boolean to string '1' or '0'
  formData.append('is_public', this.form.is_public ? '1' : '0');
  
  if (this.form.class_id) formData.append('class_id', this.form.class_id);
  if (this.form.section_id) formData.append('section_id', this.form.section_id);
  if (this.imageFile) formData.append('image', this.imageFile);
  
  this.$emit('create', formData);
  this.$emit('close');
},
      userHasBadge(badgeName) {
        return this.$parent.userHasBadge(badgeName);
      },
      async fetchSections(classId) {
  if (!classId) {
    this.sections = [];
    return;
  }
  
  this.loadingSections = true;
  try {
    const response = await api.get(`/classes/${classId}/sections`);
    // Ensure we always have an array, even if the response structure is different
    this.sections = response.data?.sections || [];
  } catch (error) {
    console.error('Error fetching sections:', error);
    this.sections = [];
  } finally {
    this.loadingSections = false;
  }
},
triggerImageUpload() {
      this.$refs.imageInput.click();
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.imageFile = file;
      this.imagePreview = URL.createObjectURL(file);
    },
    removeImage() {
      this.imageFile = null;
      this.imagePreview = null;
      this.$refs.imageInput.value = '';
    }
  
    },
    watch: {
      'form.class_id'(newVal) {
        this.form.section_id = null; // Reset section when class changes
        this.fetchSections(newVal); // Fetch sections for the new class
      }
    }
  };
  </script>
  
  <style scoped>
  
  .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999999; /* Higher than other elements */
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-custom {
  background: white;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 20px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.image-upload-container {
  margin-top: 10px;
}

.image-preview {
  width: 150px;
  height: 150px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-placeholder {
  text-align: center;
  color: #666;
}

.upload-placeholder i {
  font-size: 2rem;
  display: block;
  margin-bottom: 5px;
}
  </style>